<template>


    <div class='career-container'>
        <div class="career-bg"></div>

        <div class="career-hero-container">

             <figcaption class="page-header-description">CAREERS</figcaption>

            <div class="hero-content">
                <h1>Think you have the drive, passion, and skills we’re looking for?</h1>
                <p>As a well-established agency for over 35 years, Branton knows what it takes to be successful in this
                    industry. A key element of that success is having the best and brightest on our team to welcome all
                    challenges. If you have the talent and drive to deliver beyond the promise, send in your portfolio
                    and convince us.</p>

                <ul class="career-buttons">
                    <li v-for="(career, index) in jobs" :key='index'><a :href="'#'+career.fraction">
                            <!-- <div class="icon-container">
                                
                                <img :src="career.icon"
                                    :alt="career.title + ' Job Position Icon'">
                                <div class="icon-swiper"></div>
                            </div> -->
                            <h3>{{career.title}}</h3>
                        </a></li>
                </ul>
            </div>
        </div>

        <div v-if="activeJob" class="career-box" :class="{ 'active': lightbox}">
            <div class="career-info-container">

                <div class="career-info-panel">
                    <router-link class='careers-button' to="/careers">Close <img src="@/assets/images/close.svg"
                            alt="Close Career Box Button"></router-link>
                    <div class="info-panel-content">

                        <div class="career-head">
                            <div class="career-title">
                                <!-- <div class="icon-container">
                                    <img :src="activeJob.icon" :alt="activeJob.title + ' Job Position Icon'">
                                </div> -->
                                <h2>{{activeJob.title}}</h2>
                            </div>
                            <div class="career-link">
                                <a href="mailto:careers@branton.ca">Apply by Email</a>
                            </div>
                        </div>
                        <div class="career-listing-container">
                            <div class="career-listing" v-for="(section, index) in activeJob.sections" :key='index'>
                                <div class="section-list">
                                    <h3>{{section.title}}</h3>
                                    <ul>
                                        <li v-for="(listItem, index) in section.list" :key='index'>{{listItem}}</li>
                                    </ul>
                                </div>
                            </div>
                            <!-- <div class="career-link">
                                <a :href="activeJob.url">Apply on Indeed</a>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="career-info-image" :style="{ backgroundImage: `url('../..${activeJob.preview}')` }"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        metaInfo: {
            titleTemplate: 'Careers at Branton — A Creative Design Agency',
            meta: [{
                name: "Career Opportunities",
                content: "Think you have the drive, passion, and skills we’re looking for? View and apply to our available job opportunities."
            }]
        },
        data() {
            return {
                lightbox: false,
                jobs: {
                    juniorDesigner: {
                        title: 'Junior Designer',
                        preview: require(`@/assets/images/junior-designer-preview.jpg`),
                        icon: require(`@/assets/images/junior-designer.svg`),
                        fraction: 'junior-designer',
                        sections: [{
                                title: 'The successful candidate must have:',
                                list: [
                                    'Degree or Diploma in Graphic Design',
                                    'An ability to multi-task and manage multiple projects at the same time',
                                    'Extensive knowledge of specialized design concepts to develop comprehensive layouts and produce marketing collateral',
                                    'Proficient in Adobe CC Suite (Illustrator, Photoshop, InDesign, Acrobat)',
                                    'Proficiency in Microsoft Office Suite including Word and Excel',
                                    'An ability to interact with clients in a professional manner'
                                ]
                            },
                            {
                                title: 'Competitive advantages that would set a successful candidate apart include:',
                                list: [
                                    'Web design and development capabilities',
                                    'Video editing and post-production experience (After Effects, Premiere)',
                                    'UX/UI design experience'
                                ]
                            },
                            {
                                title: 'Core competencies:',
                                list: [
                                    'Well-established design and conceptual skills',
                                    'Effective written and verbal communication skills',
                                    'Time management for deadline-sensitive environment',
                                    'Creative and innovative thinking',
                                    'Development and continual learning',
                                    'Problem solving',
                                    'Ability to provide, accept, and integrate constructive feedback',
                                    'Self-starter who can also work in a collaborative environment'
                                ]
                            }
                        ],
                        url: 'https://indeed.ca'
                    },
                    webDeveloper: {
                        title: 'Web Designer',
                        preview: require(`@/assets/images/web-developer-preview.jpg`),
                        icon: require(`@/assets/images/developer-icon.svg`),
                        fraction: 'web-developer',
                        sections: [{
                                title: 'The successful candidate must have:',
                                list: [
                                    'Degree or Diploma in Graphic Design or Multimedia',
                                    'Use extensive knowledge of specialized design concepts, media, and software tools to develop comprehensive layouts and the production of digital marketing collateral',
                                    'Experience in Web Design & Development from concept to completion',
                                    'Knowledge of current online trends including Social Media',
                                    'Extensive knowledge of specialized design concepts to develop comprehensive layouts and produce marketing collateral',
                                    'Video Editing and Mobile App development an asset',
                                    'Design of printed graphic materials (brochures, publication ads, sales collateral)',
                                    'Ability to manage multiple projects at a time',
                                    'Interact and meet with clients in a professional manner',
                                    'Proficient in the use of the Adobe Creative Suite (InDesign, Illustrator, Photoshop, Acrobat, etc.) and Microsoft Office'
                                ]
                            },
                            {
                                title: 'Competitive advantages that would set a successful candidate apart include:',
                                list: [
                                    'Web design and development capabilities',
                                    'UX/UI design experience'
                                ]
                            },
                            {
                                title: 'Core competencies:',
                                list: [
                                    'Well-established design and conceptual skills',
                                    'Effective written and verbal communication skills',
                                    'Time management for deadline-sensitive environment',
                                    'Creative and innovative thinking',
                                    'Development and continual learning',
                                    'Problem solving',
                                    'Ability to provide, accept, and integrate constructive feedback',
                                    'Self-starter who can also work in a collaborative environment'
                                ]
                            }
                        ],
                        url: 'https://indeed.ca'
                    },
                    seniorDesigner: {
                        title: 'Senior Designer',
                        preview: require(`@/assets/images/senior-designer-preview.jpg`),
                        icon: require(`@/assets/images/senior-designer-icon.svg`),
                        fraction: 'senior-designer',
                        sections: [{
                                title: 'The successful candidate must have:',
                                list: [
                                    'Degree or Diploma in Graphic Design',
                                    '4+ years of graphic design experience (preferably in an advertising role/agency)',
                                    'Proven design capabilities as demonstrated in a portfolio',
                                    'An ability to multi-task and manage multiple projects at the same time',
                                    'Extensive knowledge of specialized design concepts to develop comprehensive layouts and produce marketing collateral',
                                    'Highly proficient in Adobe CC Suite (Illustrator, Photoshop, InDesign, Acrobat)',
                                    'Proficiency in Microsoft Office Suite including Word and Excel',
                                    'An ability to interact with clients in a professional manner'
                                ]
                            },
                            {
                                title: 'Competitive advantages that would set a successful candidate apart include:',
                                list: [
                                    'Web design and development capabilities',
                                    'Video editing and post-production experience (After Effects, Premiere)',
                                    'UX/UI design experience'
                                ]
                            },
                            {
                                title: 'Core competencies:',
                                list: [
                                    'Well-established design and conceptual skills',
                                    'Effective written and verbal communication skills',
                                    'Time management for deadline-sensitive environment',
                                    'Creative and innovative thinking',
                                    'Development and continual learning',
                                    'Problem solving',
                                    'Ability to provide, accept, and integrate constructive feedback',
                                    'Self-starter who can also work in a collaborative environment'
                                ]
                            }
                        ],
                        url: 'https://indeed.ca'
                    },
                },
                activeJob: {}
            };
        },
        methods: {
      
            needCareer: function () {
                let vm = this;
                let jobFragment = this.$route.hash;
                let job;
                if (jobFragment == "#junior-designer") {
                    job = vm.jobs.juniorDesigner;
                } else if (jobFragment == "#senior-designer") {
                    job = vm.jobs.seniorDesigner;
                } else if (jobFragment == "#web-developer") {
                    job = vm.jobs.webDeveloper;
                }

                if (!job) {
                    vm.lightbox = false;
                    document.querySelector('main').style.overflow = "visible";
                    return;
                }
                document.querySelector('body').style.overflow = "hidden";
                this.loadCareer(job);
                vm.lightbox = true;

            },
            loadCareer: function (career) {
                let vm = this;
                vm.activeJob = career;
            }
        },
        mounted() {
               this.$gtag.pageview({
        page_path: '/careers',
      })
            this.needCareer();
        },
        watch: {
            '$route.hash': function () {
                this.needCareer();
            }
        },
    }
</script>

<style lang="scss">
    @import '@/assets/css/careers.scss';
</style>